import { SelectProps } from "./select";

export enum FormTypes {
    INPUT = 'input',
    SELECT = 'select',
    TEXTAREA = 'textarea',
    DATE = 'date',
    CURRENCY = 'currency',
    IMAGE = 'image',
    CHECKBOX = 'checkbox',
    BUTTON = 'button',
    GROUPED_SELECT = 'grouped-select',
    HIDDEN = 'hidden'
}

export interface FormProps {
    name: string;
    typeOfField: FormTypes;
    placeholder: string;
    type?: string;
    label?: string;
    value?: any;
    options?: SelectProps;
    width?: number;
    height?: number;
    dateToday?: boolean;
    disabled?: boolean;
    rules?: { required?: string} | {};
    mask?: string;
    minRows?: number;
    maxRows?: number;
    fullWidth?: boolean;
    visibleWhen?: {
        fieldName: string;
        values: string[];
    };
    onSubmitForm?: (value: any | null) => void;
}
